import React, { useState } from 'react';
import { Scores } from './Scores';
import { Header } from './Header';
import { Images } from './Images';
import { Comment } from './Comment';
import { Sections } from './Sections';
import { ActionPlans } from './ActionPlans';
import { useRosaResultContext } from './context';
import { DownloadPDF } from './DownloadPDF/index';
import { RequiredElements } from './RequiredElements';
import { ReportInformation } from './ReportInformation';
import { ResultsContainer, SectionDivider } from './styles';

export function Content() {
	const [isEditing, setIsEditing] = useState<boolean>(false);

	const { rosaResult } = useRosaResultContext();
	const { images, required, action_plans } = rosaResult;

	function handleDisableFormEdition(editing: boolean): void {
		setIsEditing(editing);
	}

	return (
		<ResultsContainer>
			<Header />
			<SectionDivider type="horizontal" />
			<ReportInformation />
			<SectionDivider type="horizontal" />
			<Scores />
			<SectionDivider type="horizontal" />
			{images.length > 0 && (
				<>
					<Images />
					<SectionDivider type="horizontal" />
				</>
			)}
			<Sections />
			<SectionDivider type="horizontal" />
			{required.length > 0 && (
				<>
					<RequiredElements />
					<SectionDivider type="horizontal" />
				</>
			)}
			{action_plans.length > 0 && (
				<>
					<ActionPlans />
					<SectionDivider type="horizontal" />
				</>
			)}
			<Comment onCommentChange={handleDisableFormEdition} disableEditComment={isEditing} />
			<DownloadPDF />
		</ResultsContainer>
	);
}
